<template>
    <cart-widget-toggle-base>
        <template slot-scope="{ count, toggle }">
            <a
                class="button-cart flex"
                href="#"
                @click="toggle"
            >
                <span>
                    {{ __('Kosár') }}:
                    <span class="cart-items">{{ count }}</span> {{ __('db') }} {{ __('termék') }}
                    <span class="cart-sum">{{ formatNegativePrice(price.gross) | currency(currencyFormat(currencyValue)) }}</span>
                </span>
                <svg class="icon mx-2" aria-label="Kosár">
                    <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-cart"></use>
                </svg>
            </a>
        </template>
        <cart-widget-toggle-base/>
    </cart-widget-toggle-base>
</template>

<script>
import {mapState} from 'vuex';
import currencyFormatter from '../../mixins/currencyFormatter';

export default {
    mixins: [currencyFormatter],

    computed: {
        ...mapState('cart', [
            'price'
        ]),
    },

    props: {
        currencyValue: {
            type: String,
            required: true
        }
    }
}
</script>
